import { createSlice } from '@reduxjs/toolkit';
import { deleteRelatedReportApi } from '../../../rtk-apis/relatedReports/deleteRelatedReport';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const deleteRelatedReportSlice = createSlice({
  name: 'deleteRelatedReports',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(deleteRelatedReportApi.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
      })
      .addCase(deleteRelatedReportApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(deleteRelatedReportApi.rejected, (state, action: any) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export default deleteRelatedReportSlice.reducer;
export const { clearState } = deleteRelatedReportSlice.actions;
